import React from "react";
import styled from 'styled-components';
import { Card } from 'react-bootstrap';
import { useStaticQuery, graphql } from "gatsby"
import { StaticImage } from 'gatsby-plugin-image';

export default function Profile(){
  const data = useStaticQuery(
    graphql`
      query {
        site {
          siteMetadata {
            profile{
              name
              description
            }
          }
        }
      }
    `
  )
  const Wrapper = styled.div`
    .name,.icon{ text-align: center; margin-top:5px; font-weight: bold; }
    .gatsby-image-wrapper-constrained img{ text-align: center; border:2px solid black; overflow:hidden; border-radius:50%; }
    .description{ font-size:12px; margin-top:5px; }
    .card-header{ background-color:#333; text-align:center; font-size:12px; font-weight:bold; color:white; }
  `
  const {name,description} = data.site.siteMetadata.profile
  return (
    <Wrapper>
      <Card className="profile">
        <Card.Header>運営者</Card.Header>
        <Card.Body>
          <div className="icon">
            <StaticImage alt="プロフィール画像" width={70} src="../../../images/icon/profile2.png"/>
          </div>
          <div className="name">{name}</div>
          <div className="description">{description}</div>
        </Card.Body>
      </Card>
    </Wrapper>
  )
}